/* eslint-disable eqeqeq */
import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { getProducts } from '../utils/api';
import { useLanguage } from '../store/languageContext';
import { FaWhatsapp } from "react-icons/fa";
import translate from '../utils/translation';
const ProductDetail = () => {
    const { id } = useParams();
    const [product, setProduct] = useState(null);
    const [currentImage, setCurrentImage] = useState(0);
    const [loading, setLoading] = useState(true);
    const { language, setNavColor } = useLanguage();
    const sectionRef = useRef(null);
    useEffect(() => {
        getProducts({}).then((res) => {
            const foundProduct = res.data.find((p) => p.id == id);
            if (foundProduct) {
                const parsedProduct = {
                    ...foundProduct,
                    images: JSON.parse(foundProduct.images || '[]'),
                    specifications: JSON.parse(foundProduct.specifications || '{}'),
                };
                setProduct(parsedProduct);
            }
            setLoading(false);
        });
    }, [id]);
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setNavColor('white');
                }
            },
            {
                threshold: 0.1,
                rootMargin: '-50px 0px -20% 0px',
            }
        );

        const currentRef = sectionRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [setNavColor]);
    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="loader border-4 border-gray-200 border-t-gray-500 rounded-full w-12 h-12 animate-spin"></div>
            </div>
        );
    }

    if (!product) {
        return (
            <section ref={sectionRef} className='bg-[#222] min-h-screen pt-[120px] sm:pt-[150px] px-4'>
                <div className='flex items-center justify-center text-xl sm:text-3xl font-bold text-white py-20'>Product not found.</div>
            </section>
        );
    }

    const { images, specifications: specs, title, description, price, brand_name, category, update_date } = product;
    const navigateWhatsApp = (productTitle) => {
        const currentTime = new Date();
        const hours = currentTime.getHours();
        const greeting = hours < 12 ? 'صباح الخير' : 'مساء الخير';
        const message = ` ${greeting}, أود الاستفسار عن المنتج: ${productTitle} 
        . يرجى التواصل معي.
        شكراً جزيلاً!`;
        const url = `https://wa.me/+201117169426?text=${encodeURIComponent(message)}`;
        return () => {
            window.open(url, '_blank');
        }
    }
    return (
        <section ref={sectionRef} className='bg-[#222] min-h-screen pt-[100px] sm:pt-[130px] md:pt-[150px] pb-10'>
            <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 max-w-6xl mx-auto px-4 sm:px-6">
                <div className="w-full lg:w-3/5 flex flex-col gap-4">
                    <div className="w-full h-[280px] sm:h-[380px] md:h-[450px] lg:h-[500px] flex items-center justify-center bg-[#1a1a1a] rounded overflow-hidden">
                        <img
                            src={images[currentImage] || images[0]}
                            alt={title}
                            className="w-full h-full object-cover border border-gray-600"
                        />
                    </div>
                    {images.length > 1 && (
                        <ul className="flex items-center gap-2 sm:gap-3 overflow-x-auto pb-1">
                            {images.map((img, i) => (
                                <li key={i} className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 flex-shrink-0">
                                    <img
                                        src={img}
                                        alt={`${title} thumbnail ${i + 1}`}
                                        className={`h-full w-full object-cover cursor-pointer border border-gray-600 transition-opacity rounded ${currentImage === i ? 'opacity-100' : 'opacity-40'}`}
                                        onClick={() => setCurrentImage(i)}
                                    />
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                <div className="w-full lg:w-2/5 border border-gray-600 p-4 sm:p-5 md:p-6 flex flex-col">
                    {brand_name && (
                        <p className="text-xs sm:text-sm text-gray-500 mb-2 capitalize">{brand_name} - {category}</p>
                    )}
                    <h1 className="font-normal text-xl sm:text-2xl mb-2 text-white">{title}</h1>

                    <div className="mb-2 text-base sm:text-lg flex justify-between items-center">
                        <span className="flex items-center">
                            <span className="text-red-500 mr-1">{price} {translate[language].egp}</span>
                        </span>
                    </div>

                    <p className="mb-3 text-gray-500 text-xs sm:text-sm">
                        {translate[language].LastUpdated}: {new Date(update_date).toLocaleDateString()}
                    </p>

                    <p className="mb-4 break-words text-gray-400 leading-relaxed text-sm sm:text-base">{description}</p>

                    {Object.keys(specs).length > 0 && (
                        <div className="mb-4">
                            <h5 className="text-lg sm:text-xl font-light text-gray-400 mb-2">{translate[language].Specifications}</h5>
                            <ul className="text-xs sm:text-sm space-y-1">
                                {Object.entries(specs).map(([key, value]) => (
                                    <li key={key} className="text-gray-200 capitalize">
                                        <span className="font-medium">- {key.replace(/_/g, ' ')}:</span> <span className='opacity-70'>{String(value)}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                    <button
                        className="text-center flex justify-center items-center py-3 sm:py-4 px-6 sm:px-8 transition-all text-base sm:text-lg border-none mt-auto w-full cursor-pointer bg-green-400 hover:bg-green-500 rounded text-black font-medium"
                        onClick={navigateWhatsApp(title)}
                    >
                        <FaWhatsapp className="inline-block mx-2 size-5" /> {translate[language]['contactUs']}
                    </button>
                </div>
            </div>
        </section>
    );
};

export default ProductDetail;